export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classement réseau"])},
        "store_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
        "total_reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gain total"])},
        "current_store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["votre magasin"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir moins"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network ranking"])},
        "store_name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
        "total_reward": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total reward"])},
        "current_store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["your store"])},
        "show_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show more"])},
        "show_less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show less"])}
      }
    }
  })
}
